<template>
  <transition name="modal">
    <div class="modal-mask" ref="mask">
      <div class="modal-wrapper">
        <div class="modal-container" ref="modal">

          <div class="modal-header">
            <slot name="header">
              <span class="header-title">{{ headerTitle }}</span>
              <span class="header-close-icon" @click="$emit('cancel')"><i class="fal fa-times-circle"></i></span>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <a @click="$emit('cancel')" class="modal-default-button cancel-button btn btn-default excluded">{{ cancelLabel }}</a>
              <a @click="$emit('submit')" class="modal-default-button ok-button btn btn-primary excluded" :disabled="submitDisabled">{{ submitLabel }}</a>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "vyModal",
    props: {
      cancelLabel: { type: String, default: 'Cancel' },
      // This prop takes an array of class strings so test against in outsideClickListener.
      // The goal is to circumvent bugs when a modal contains a component with elements that need to be clicked, but will
      // disappear after they are clicked and thus will be interpreted by the modal as an outside click (e.g. the filter component's dropdown list).
      headerTitle: { type: String, default: '' },
      outsideClickWhitelist: { type: Array, default: () => [] },
      submitDisabled: { type: Boolean, default: false },
      disabledClickOutside: { type: Boolean, default: false },
      submitLabel: { type: String, default: 'OK' },
    },
    methods: {
      outsideClickListener: function(event) {
        let self = this;
        let modalElement = this.$refs.modal;
        if (!modalElement.contains(event.target) && document.contains(event.target)) {
          let isWhitelisted = false;
          self.outsideClickWhitelist.some(cls => {
            if (event.target.classList.contains(cls)) {
              isWhitelisted = true;
              return true;
            }
          });
          if (!isWhitelisted) {
            self.$emit('close');
            self.$refs.mask.removeEventListener('click', self.outsideClickListener);
            event.stopImmediatePropagation();
          }
        }
      }
    },
    mounted: function() {
      if (!this.disabledClickOutside) {
        this.$refs.mask.addEventListener('click', this.outsideClickListener);
      }
      $(window).on('hashchange', () => {
        this.$emit('cancel');
      });
    },
    beforeDestroy: function() {
      this.$refs.mask.removeEventListener('click', this.outsideClickListener);
    },
  }
</script>

<style lang="scss" scoped>
$modal-header-height: 75px;
$footer-height: 72px;
$modal-max-height: calc(100vh - 40px);

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;


    .modal-container {
      min-width: 300px;
      margin: 0px auto;
      background-color: var(--panel-background);
      scrollbar-color: var(--scrollbar-thumb-color) var(--panel-background);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
      padding: 0;
      width: 1090px;
      max-width: calc(100vw - 40px);
      max-height: $modal-max-height;
      display: flex;
      flex-direction: column;
      border-radius: 24px;

      .modal-header {
        height: $modal-header-height;
        font-family: var(--font-family);
        font-weight: 700;
        text-align: center;
        color: var(--text-color);
        background-color: var(--panel-background-color);
        font-size: 18px;
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
        padding: 20px;

        .header-title {
          display: inline-block;
          text-transform: capitalize;
        }

        .header-close-icon {
          float: right;
          font-size: 24px;
          color: #6D787E;
          position: relative;
          bottom: 10px;
          left: 10px;
          cursor: pointer;

          &:hover {
            color: var(--text-color);
          }
        }
      }

      .modal-body {
        padding: 15px;
        color: var(--text-color);
      }

      .modal-footer {
        height: $footer-height;
        min-height: 25px;
        padding: 17px;
        display: flex;
        justify-content: end;
      }
    }
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>